import { CheckCircle2, AlertTriangle, Save, Eye, Loader2, Target } from "lucide-react";

export function LayoutStatus({ refs, refKey, setRefKey, count, planned, dirty, saving, canPreview, onApplyPlanned, onPreview, onSave }) {
  const ref = refs.find((r) => r.key === refKey);
  const delta = count - planned;
  const match = ref && delta === 0 && count > 0;
  return (
    <div className="rounded-xl border border-zinc-800 bg-[#0F0F11] p-3 space-y-3" data-testid="roof-layout-status">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <label className="flex items-center gap-2 text-[12px] text-zinc-400 min-w-0">
          <span className="text-[10.5px] uppercase tracking-widest font-bold text-zinc-500">Bezug</span>
          <select value={refKey} onChange={(e) => setRefKey(e.target.value)} data-testid="roof-layout-ref-select"
            className="h-9 max-w-[17rem] bg-zinc-900 border border-zinc-700 rounded-lg px-2 text-[12.5px] text-zinc-100">
            {refs.length === 0 && <option value="">Noch keine Konfiguration</option>}
            {refs.map((r) => <option key={r.key} value={r.key}>{r.label} · {r.modules} Module</option>)}
          </select>
        </label>
        <div className="flex items-baseline gap-4 font-mono">
          <span className="text-[12px] text-zinc-400">Im Bild <b className="text-[18px] text-zinc-50" data-testid="roof-layout-count">{count}</b></span>
          <span className="text-[12px] text-zinc-400">Geplant <b className="text-[18px] text-zinc-300" data-testid="roof-layout-planned">{ref ? planned : "–"}</b></span>
          {ref && delta !== 0 && (
            <span className="px-2 py-0.5 rounded-md bg-amber-500/15 border border-amber-500/40 text-amber-300 text-[12px] font-bold" data-testid="roof-layout-delta">
              {delta > 0 ? `+${delta}` : delta}
            </span>
          )}
        </div>
      </div>
      <p className={`text-[12px] flex items-start gap-1.5 ${match ? "text-[#00E575]" : "text-zinc-400"}`} data-testid="roof-layout-hint">
        {match ? <CheckCircle2 size={14} className="shrink-0 mt-px" /> : <AlertTriangle size={14} className="shrink-0 mt-px text-amber-400" />}
        {!ref && "Lege zuerst eine Konfiguration oder ein Angebot an – oder setze Module per „Hinzufügen“."}
        {ref && match && (ref.kind === "offer"
          ? "Passt zum Angebot – der Belegungsplan erscheint im PV-Angebot-PDF."
          : "Passt zur Konfiguration – Angebote daraus enthalten den Belegungsplan.")}
        {ref && !match && count > 0 && `Beim Speichern wird ${ref.label} auf ${count} Module angepasst – kWp und Preis werden neu berechnet.`}
        {ref && count === 0 && "Noch keine Module im Bild."}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        {ref && delta !== 0 && planned > 0 && (
          <button type="button" onClick={onApplyPlanned} data-testid="roof-layout-apply-planned"
            className="h-10 px-3 rounded-lg border border-zinc-700 bg-zinc-900 text-zinc-200 text-[12.5px] font-bold inline-flex items-center gap-1.5 hover:bg-zinc-800">
            <Target size={14} /> Auf {planned} Module setzen
          </button>
        )}
        <button type="button" onClick={onPreview} disabled={!canPreview || dirty} data-testid="roof-layout-preview"
          title={dirty ? "Erst speichern, dann Vorschau öffnen" : "So erscheint der Plan im PDF"}
          className="h-10 px-3 rounded-lg border border-sky-500/40 text-sky-200 text-[12.5px] font-bold inline-flex items-center gap-1.5 hover:bg-sky-500/10 disabled:opacity-40">
          <Eye size={14} /> PDF-Vorschau
        </button>
        <button type="button" onClick={onSave} disabled={saving} data-testid="roof-layout-save"
          className="ml-auto h-10 px-4 rounded-lg bg-[#00E575] hover:bg-[#00C964] text-[#09090B] text-[13px] font-extrabold inline-flex items-center gap-1.5 active:scale-[0.98] transition-transform disabled:opacity-60">
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />}
          Belegung speichern{dirty ? " *" : ""}
        </button>
      </div>
    </div>
  );
}
